/** Spanish (es). Mirror of `en.ts`. */
export const es: Record<string, string> = {
  "nav.terminal": "Terminal",
  "nav.portfolio": "Cartera",
  "nav.orders": "Órdenes",
  "nav.fills": "Ejecuciones",
  "nav.alerts": "Alertas",
  "nav.discover": "Descubrir",
  "nav.complaints": "Reclamaciones",
  "nav.account": "Cuenta",
  "nav.api_keys": "Claves API",
  "nav.tearsheet": "Informe de rendimiento",
  "nav.profile": "Perfil y MFA",

  "common.save": "Guardar",
  "common.cancel": "Cancelar",
  "common.delete": "Eliminar",
  "common.loading": "Cargando…",
  "common.error.generic": "Algo salió mal. Por favor reintenta.",

  "auth.login.title": "Iniciar sesión",
  "auth.login.email": "Correo electrónico",
  "auth.login.password": "Contraseña",
  "auth.login.submit": "Entrar",
  "auth.login.demo": "Abrir cuenta demo",

  "complaint.cta.new": "Nueva reclamación",
  "complaint.empty": "Sin reclamaciones",

  "apikey.title": "Claves API",
  "apikey.description": "Acceso programático para clientes sin interfaz.",
  "apikey.create": "Crear clave",
  "apikey.revoke": "Revocar",
  "apikey.warn.once": "Esta es la única vez que se muestra la clave en texto claro.",
};
